export default __webpack_public_path__ + "fa6e67cc46c2dd17319e0bafc9fcc9ca.png";